/**
 * useDevToolsGuard — Disables browser DevTools keyboard shortcuts and
 * right-click context menu in production builds.
 *
 * Activate: import and call once in App.js root.
 * Active only when: process.env.NODE_ENV === 'production'
 * Does NOT affect preview / dev builds.
 */
import { useEffect } from 'react';

export function useDevToolsGuard() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return; // dev / preview: no-op
    if (process.env.REACT_APP_DEVTOOLS_ALLOWED === 'true') return; // developer build bypass

    // ── Block keyboard shortcuts that open DevTools ──────────────────────
    const handleKey = (e) => {
      // F12
      if (e.key === 'F12') { e.preventDefault(); return false; }
      // Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C / Ctrl+Shift+K
      if ((e.ctrlKey || e.metaKey) && e.shiftKey &&
          ['i', 'I', 'j', 'J', 'c', 'C', 'k', 'K'].includes(e.key)) {
        e.preventDefault(); return false;
      }
      // Ctrl+U (view source)
      if ((e.ctrlKey || e.metaKey) && (e.key === 'u' || e.key === 'U')) {
        e.preventDefault(); return false;
      }
      // Ctrl+S (save page)
      if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) {
        e.preventDefault(); return false;
      }
    };

    // ── Disable right-click context menu globally ────────────────────────
    const handleContext = (e) => {
      e.preventDefault();
      return false;
    };

    document.addEventListener('keydown', handleKey, true);
    document.addEventListener('contextmenu', handleContext, true);

    return () => {
      document.removeEventListener('keydown', handleKey, true);
      document.removeEventListener('contextmenu', handleContext, true);
    };
  }, []);
}
